export default __webpack_public_path__ + "static/media/c9f372bccdbb567650aa42f187552cbc1602164011863.1fbefda2.webp";